import GroupEdit from './group.edit';
import GroupCreate from './group.create';
import GroupShow from './group.show';

export default {
  edit: GroupEdit,
  create: GroupCreate,
  show: GroupShow,
};
